import { Icon, iconVariants } from '@fountain/ripple/icon';
import classNames from 'classnames';
import React from 'react';

import { useStyles } from './StageIcon.styles';
import {
  resolveStageIconKey,
  StageIconProps,
  STAGE_ICON_SIZE_BY_SURFACE,
  STAGE_KEY_ICONS,
} from './stageIconTable';

export type { StageIconProps } from './stageIconTable';

export function StageIcon({
  type,
  shortType,
  surface,
  isSelected,
  className,
}: StageIconProps) {
  const classes = useStyles();
  const key = resolveStageIconKey({ type, shortType, surface });
  if (key === null) return null;

  const Glyph = STAGE_KEY_ICONS[key];
  const size = STAGE_ICON_SIZE_BY_SURFACE[surface];
  const testId =
    key === 'ai-interview'
      ? 'AIInterviewIcon'
      : type
        ? `${type}Icon`
        : undefined;
  const isTile =
    surface === 'workflowEditor' ||
    surface === 'aiBuilder' ||
    surface === 'assessmentHeader';

  return isTile ? (
    <span
      className={classNames(
        classes.tile,
        { [classes.largeTile]: size === 'lg' },
        classes[key],
        className,
      )}
      data-testid={testId}
    >
      <Glyph className={iconVariants({ size })} />
    </span>
  ) : (
    <Icon
      icon={Glyph}
      size={size}
      color={isSelected ? 'white' : 'neutral-400'}
      className={className}
      data-testid={testId}
    />
  );
}
